import { log } from '../logWrapper';

/**
 * 印刷処理を共通化
 * @param {HTMLElement} element 印刷対象の要素
 * @param {string} title 印刷プレビューのタイトル
 * @param {boolean} applyStyles スタイルを適用するかどうか
 */
export function printContent(element, title, applyStyles = true) {
  if (!element) {
    log('印刷エラー', '印刷対象の要素が見つかりません', true);
    return;
  }

  let head = '';
  if (applyStyles) {
    Array.from(document.styleSheets).forEach(styleSheet => {
      try {
        if (styleSheet.href) {
          // 外部スタイルシートの場合
          head += `<link rel="stylesheet" type="text/css" href="${styleSheet.href}">`;
        } else if (styleSheet.cssRules) {
          // インラインスタイルの場合
          const cssText = Array.from(styleSheet.cssRules).map(rule => rule.cssText).join('\n');
          head += `<style>${cssText}</style>`;
        }
      } catch (e) {
        log('スタイルシート読み込みエラー', styleSheet, true);
      }
    });
  }

  // 印刷プレビューHTML作成
  let htmlContent = '';
  htmlContent = '<!DOCTYPE html>';
  htmlContent += '<html>';
  htmlContent += `<head>${head}<title>${title}</title></head>`;
  htmlContent += `<body>${element.outerHTML}</body>`;
  htmlContent += '</html>';

  // Blob を使用して印刷プレビューを生成
  const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  // 印刷プレビュー画面表示
  const printWin = window.open(url, '', 'width=1065, height=565, toolbar=0, scrollbars=0, status=0');

  printWin.onload = function () {
    // すべての画像が読み込まれた後に印刷を実行
    printWin.focus();
    printWin.print();
    printWin.onafterprint = function () {
      // 印刷後にURLを解放してリソースを節約
      URL.revokeObjectURL(url);
      printWin.close();
    };
  };
}

/**
 * 印刷処理を共通化
 * @param {string} imagePath 画像パス
 * @param {callback} callback 実行したいコールバック関数
 */
export function loadImageAsBase64(imagePath, callback) {
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result); // Base64 データをコールバックで返す
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', imagePath);
  xhr.responseType = 'blob';
  xhr.send();
}